<template>
  <div>
    <form action="https://kaspi.kz/online" method="post" ref="kaspiform" v-if="order">
      <input type="hidden" name="TranId" :value="order.id">
      <input type="hidden" name="OrderId" :value="order.id">
<!--      <input type="hidden" name="Amount" :value="(order.price * 100)">-->
      <input type="hidden" name="Amount" :value="amountToPay">
      <input type="hidden" name="Service" value="topbiletkz">
<!--      <input type="hidden" name="returnUrl" :value="`https://api.topbilet.kz/order/kaspi-success/${order.id}`">-->
      <input type="hidden" name="returnUrl" :value="`https://api.topbilet.kz/payment/${order.id}/${order.hash}/success`">
      <button class="btn btn-danger" style="display: none;" type="submit"></button>
  </form>

  </div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: "KaspiForm",
  props: {
    order: {},
  },
  computed: {
    ...mapGetters(['totalWithFeeAndRefundable']),
    amountToPay() {
      return Math.round(this.totalWithFeeAndRefundable * 100)
    }
  },
  methods: {
    submit() {
      this.$refs.kaspiform.submit()
    },
  }
}
</script>
